export const MmaoDialogStyles = {
  width: '600px',
};
